import { PkButton } from '@uefadigital/panenka-react';
import parseHtmlToReact from 'html-react-parser';
import { memo, useMemo } from 'react';

import { getTicketPriceFormatted } from '@apps/ticketing/utils/data';
import type { EditorialContent } from '@cobalt/utilities';
import { getTicketInfo } from '@cobalt/utilities';
import { useTranslateFn } from '@shared/Translate';
import { competitionCode } from '@utilities/WindowContext';

import * as css from './styles.module.scss';

const BoxPrice = ({
  article,
  onButtonClick,
}: {
  article: EditorialContent;
  onButtonClick?: (article: EditorialContent) => void;
}) => {
  const t = useTranslateFn();

  const boxAndCtaText = article?.document?.content
    .filter((o) => o._type === 'EXTRA')
    .flatMap((p) => p._json.filter((c) => c._type !== 'EXTRA'))
    .map((j) => j._html);

  const handleClick = () => {
    onButtonClick && onButtonClick(article);
  };

  const ticket = useMemo(() => getTicketInfo(article), [article]);
  const priceFormatted = useMemo(() => (ticket?.ticketPrice ? getTicketPriceFormatted(ticket) : ''), [ticket]);
  if (!article) return null;

  return (
    <div className={css.boxPrice}>
      <div className={css.boxText}>
        {boxAndCtaText.map((j, k) => k < 2 && <div key={k}>{parseHtmlToReact(j)}</div>)}
      </div>

      <div className={css.cta}>
        <div className={css.ctaText}>
          {boxAndCtaText.map((j, k) => k > 1 && <div key={k}>{parseHtmlToReact(j)}</div>)}
        </div>
        <div className={css.priceWrapper}>
          <div className={css.price}>
            <span data-test-id='price'>{priceFormatted}</span>
            <br />
            {t(`hospitality_price_vat_${competitionCode}`)}
          </div>
          <div className={css.button}>
            <PkButton width='auto' onClick={handleClick} className={css.button}>
              {article.document.content.filter((o) => o._type === 'LINK').map((p) => parseHtmlToReact(p._html))}
            </PkButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(BoxPrice);
